import React, { useContext } from 'react';
import unescape from 'lodash/unescape';
import clsx from 'clsx';
import { useReactlytics } from '@americanexpress/reactlytics';
import { useDispatch } from 'react-redux';
import { sanitize } from '@americanexpress/consumer-travel-base';
import { Button } from '@americanexpress/dls-react';
import styles from '../Suggestions.scss';
import locationContext from '../../../context/locationsContext';
import { locationShape } from '../../../shape/locationShape';
import { RECENT_SEARCHES_KEY } from '../../../constants/categoryConstants';
import { getAnalyticsUtils } from '../../../utils/getAnalyticsUtils';
import { postContextFeedbackThunk } from '../../../thunks/postContextFeedbackThunk';
import { useRecentSearchAPI, useRecentSearchData } from '../../../hooks/apiHooks';

const SuggestionItemRedesign = ({
  id, name, label, airportCode, parentId, type,
  geoLocation, searchIdType, suggestionIndex,
  toLabel, toAirportCode, dates,
}) => {
  const {
    state: {
      location,
      focusedLocationRef,
      isRoundTrip,
    },
    actions: {
      selectLocation,
    },
    config: {
      lineOfBusiness,
    },
  } = useContext(locationContext);
  const printedName = `${parentId ? '> ' : ''}${name}`;
  const { track } = useReactlytics();
  const dispatch = useDispatch();
  const recentSearchData = useRecentSearchData();
  const { trackingId } = useRecentSearchAPI();

  const handleSelect = () => {
    selectLocation({
      id,
      name,
      label,
      airportCode,
      parentId,
      type,
      geoLocation,
      toLabel,
      toAirportCode,
      dates,
      searchIdType,
    });
  };

  const triggerAnalytics = () => {
    track({
      event: {
        element: getAnalyticsUtils({
          type,
          lob: lineOfBusiness,
          isRoundTrip,
          suggestionIndex,
        }),
        detail: 'recent-search-selected',
        type: 'click',
      },
    });
  };
  const onClick = () => {
    handleSelect();
    if (type === RECENT_SEARCHES_KEY) {
      triggerAnalytics();
      dispatch(postContextFeedbackThunk({
        recentSearchData,
        eventType: 'click',
        lob: lineOfBusiness,
        suggestionIndex,
        trackingId,
      }));
    }
  };

  return (
    <Button
      variant="tertiary"
      className={clsx(
        styles.suggestion,
        'flex-align-center text-align-left width-full fluid pad-0-r pad-0-tb pad-3-l',
        { 'focus-light': focusedLocationRef === suggestionIndex }
      )}
      key={suggestionIndex}
      role="option"
      id={`suggestion-${suggestionIndex}`}
      aria-selected={id === location?.id}
      aria-current={id === location?.id}
      onClick={onClick}
      onKeyDown={handleSelect}
      tabIndex={-1}
    >
      <p
        className="body margin-2-l"
        // eslint-disable-next-line react/no-danger -- value from oneCMS
        dangerouslySetInnerHTML={{ __html: unescape(sanitize(printedName)) }}
      />
    </Button>
  );
};

SuggestionItemRedesign.propTypes = locationShape;

export { SuggestionItemRedesign as TestableSuggestion };
export default SuggestionItemRedesign;
